// Per-rodeo "Entered" flag (you've actually put your entry in). Default: not entered.
export function getEntered() {
  try { return JSON.parse(localStorage.getItem("rp_entered") || "{}"); }
  catch { return {}; }
}
export function isEntered(id) {
  return !!getEntered()[id];
}
export function setEntered(id, val) {
  const e = getEntered();
  if (val) e[id] = true; else delete e[id];
  localStorage.setItem("rp_entered", JSON.stringify(e));
  return e;
}
